<template>
  <b-form-group :label-class='labelclass' :label="label" :class="`${classFormGroupBind} b-form-group-styled`" :invalid-feedback="invalidFeedback"
    :description="descriptionField" :state="error && error.$error ? false : null">
    <b-form-input class="b-form-input-styled" :value="value" @input="($value) => $emit('input', $value)"
      @blur="($value) => $emit('blur')" v-bind="$attrs" :readonly="readonly"
      :state="error && error.$error ? false : null" size="sm" :required="required" :formatter="formatter"
      :type="type"></b-form-input>
  </b-form-group>
</template>
<script>
export default {
  inheritAttrs: false,
  props: {
    cols: String,
    sm: String,
    md: String,
    type: {
      type: String,
      default: "text",
    },
    labelclass: {
      type: String,
      default: "",
    },
    classFormGroup: {
      type: String,
      default: "",
    },
    label: String,
    value: [String, Number],

    invalidFeedback: {
      typeof: String,
      default: null,
    },
    description: {
      typeof: String,
      default: "",
    },
    error: {
      type: Object,
      default: null,
    },
    readonly: {
      type: Boolean,
      default: false,
    },
    required: {
      type: Boolean,
      default: false,
    },
    formatter: {
      type: Function,
      default: null,
    },
  },
  computed: {
    classFormGroupBind() {
      const responsiveCols =
        (this.cols !== undefined ? `col-${this.cols} ` : "") +
        (this.sm !== undefined ? `col-sm-${this.sm} ` : "") +
        (this.md !== undefined ? `col-md-${this.md} ` : "") || "col-12 "
      return `${responsiveCols} ${this.classFormGroup}`
    },

    descriptionField() {
      if (this.readonly) {
        return ""
      }
      return this.error && this.error.$error ? "" : this.description
    },
  },
}
</script>
<style scoped>
.b-form-group-styled {
  font-size: 12px;
}

.b-form-input-styled {
  max-height: 24px;
  margin-top: -8px;
}
</style>
